import React, { useMemo } from 'react';
import { DATE_LONG_FORMAT_WITH_YEAR_AND_DAYOFWEEK } from '../../../../../data/constants/datetime';
import { eventMomentFactory } from '../../../../../data/misc/eventMomentFactory';
import SafeImage from '../../../../elements/SafeImage';
import TimeSpan from '../../../../elements/TimeSpan';
import styles from './MeetingTimeAndLocation.module.scss';
import ClockIcon from './clock.svg';
import PinIcon from '../../../../../resources/icons/location-pin.svg';
import SectionTitle from '../common/SectionTitle';

function MeetingTimeAndLocation(props) {
    const { className = '', event, meeting } = props,
        formattedTime = useMemo(() => eventMomentFactory(event, meeting.start_local).format(DATE_LONG_FORMAT_WITH_YEAR_AND_DAYOFWEEK), [event, meeting]);

    return (
        <div className={[className, styles.MeetingTimeAndLocation].join(' ')}>
            {/* <h3 className={styles.date}>{formattedTime}</h3> */}
            <SectionTitle className={styles.date}>{formattedTime}</SectionTitle>
            <div className={styles.wrapper}>
                <ClockIcon className={styles.icon} />
                <TimeSpan className={styles.timespan} startClassName={styles.start} endClassName={styles.end} start={meeting.start_local} end={meeting.end_local} />
                <div className={styles.content}>
                    <div className={styles.title}>{meeting.name}</div>
                    <div className={styles.location}>
                        <PinIcon /> {meeting.location.name}
                    </div>
                </div>
                {meeting.location.image_url ? <SafeImage src={meeting.location.image_url} className={styles.locationImage} /> : null}
            </div>
        </div>
    );
}

export default MeetingTimeAndLocation;
